import React from "react"

export const TablePaginationLink = ({
  current_notice_slice,
  set_current_notice_slice,
  i,
  scroll_top_smooth,
}) => {
  const set_slice = (e) => {
    e.preventDefault()
    set_current_notice_slice(i)
    setTimeout(() => {
      scroll_top_smooth()
    }, 250)
  }
  return (
    <li>
      <a
        onClick={set_slice}
        className={`pagination-link ${
          i === current_notice_slice ? "is-current" : ""
        }`}
        href=" #"
        aria-label="Vor-Vorherige Seite"
      >
        {i + 1}
      </a>
    </li>
  )
}
